/*
 *  I01DEPBOUCECSCalcul.js
 *
 *  Created by Sébastien Hecart on 2017-12-20 16:58:47 +0000.
 *  Copyright © 2017 Sebastien Hecart. All rights reserved.
 *
 *
 */

import { fetchIsolant, fetchTube, fetchPerteChargeUnite } from '@batical/data/src'
import { RTubes_Type, RIsolantECS_Type, I01DEPBOUCECS_State } from '@batical/types/src'

function I01DEPBOUCECS_docalcul(state: I01DEPBOUCECS_State) {
  const ret_isolant = fetchIsolant(state.ret_isolantSelected)
  const tube_ret = fetchTube(state.tube_ret_uuid)
  const pdcUnit = fetchPerteChargeUnite(state.pdcUnitSelected_uuid)
  const dep_isolant = fetchIsolant(state.dep_isolantSelected)
  const tube_dep = fetchTube(state.tube_dep_uuid)

  const perteChargeUniteMH20Factor = 0.0001019
  let res_dep_resi_totale = 0
  if (tube_dep && tube_ret && dep_isolant && ret_isolant && dep_isolant && pdcUnit) {
    res_dep_resi_totale = calculResistance(
      state.in_temp_dep_boucleECS,
      state.in_temp_dep_moyenne_ambiance,
      state.in_dep_epaisseur,
      tube_dep,
      dep_isolant
    )

    state.res_dep_puiss_par_m = (state.in_temp_dep_boucleECS - state.in_temp_dep_moyenne_ambiance) / res_dep_resi_totale
    state.res_dep_puiss_nec_conduite = state.res_dep_puiss_par_m * state.in_dep_long_tuyauterie
    // vitesse =(C18/3600000)/((PI()*(I8)^2)/4))
    state.res_dep_vitesse = state.in_dep_boucle_ailee / 3600000 / ((Math.PI * Math.pow(tube_dep.diamInt / 1000, 2)) / 4)
    //delta temp  C19-(((C18/3600)*4180*C19)-(C17))/(4180*(C18/3600)))
    let res_dep_delta_temp =
      state.res_dep_vitesse -
      ((state.in_dep_boucle_ailee / 3600) * 4180 * state.res_dep_vitesse - state.res_dep_puiss_nec_conduite) /
        ((4180 * state.in_dep_boucle_ailee) / 3600)

    let res_dep_temp_fin_boucle = state.in_temp_dep_boucleECS - res_dep_delta_temp

    state.res_dep_pdc =
      (((0.00046 * Math.pow(Math.pow(state.res_dep_vitesse, 7) / (tube_dep.diamInt / 1000), 1 / 4)) / (tube_dep.diamInt / 1000)) *
        pdcUnit.factor) /
      perteChargeUniteMH20Factor
    const res_dep_pdc_total = state.res_dep_pdc * state.in_dep_long_tuyauterie
    state.res_dep_pdc = res_dep_pdc_total
    const res_ret_resi_totale = calculResistance(
      res_dep_temp_fin_boucle,
      state.in_ret_temp_ambiance,
      state.in_ret_epaisseur,
      tube_ret,
      ret_isolant
    )
    state.res_ret_puiss_par_m = (res_dep_temp_fin_boucle - state.in_ret_temp_ambiance) / res_ret_resi_totale

    state.res_ret_puiss_nec_conduite = state.res_ret_puiss_par_m * state.in_ret_long_tuyauterie
    // vitesse =(C18/3600000)/((PI()*(I8)^2)/4))
    state.res_ret_vitesse = state.in_dep_boucle_ailee / 3600000 / ((Math.PI * Math.pow(tube_ret.diamInt / 1000, 2)) / 4)
    //delta temp  C19-(((C18/3600)*4180*C19)-(C17))/(4180*(C18/3600)))
    const res_ret_delta_temp =
      state.res_ret_vitesse -
      ((state.in_dep_boucle_ailee / 3600) * 4180 * state.res_ret_vitesse - state.res_ret_puiss_nec_conduite) /
        ((4180 * state.in_dep_boucle_ailee) / 3600)
    state.res_ret_temp_fin_boucle = res_dep_temp_fin_boucle - res_ret_delta_temp
    state.res_ret_pdc =
      (((0.00046 * Math.pow(Math.pow(state.res_ret_vitesse, 7) / (tube_ret.diamInt / 1000), 1 / 4)) / (tube_ret.diamInt / 1000)) *
        pdcUnit.factor) /
      perteChargeUniteMH20Factor
    const res_ret_pdc_total = state.res_ret_pdc * state.in_ret_long_tuyauterie
    state.res_ret_pdc = res_ret_pdc_total
    state.res_total_deperdition = state.res_dep_puiss_nec_conduite + state.res_ret_puiss_nec_conduite
    state.res_total_pdc = res_dep_pdc_total + res_ret_pdc_total
  }
  state.invalidated = false
  return state
}

// function resetResult() {
//   state.res_ret_resi_totale = 0.0;
//   state.res_ret_vitesse = 0.0;
//   state.res_ret_puiss_par_m = 0.0;
//   state.res_ret_puiss_nec_conduite = 0.0;
//   state.res_ret_delta_temp = 0.0;
//   state.res_ret_temp_fstate.in_boucle = 0.0;
//   state.res_ret_pdc = 0.0;
//   state.res_ret_pdc_total = 0.0;
//   //MARK: totla

//   state.res_total_pdc = 0.0;
//   state.res_total_deperdition = 0.0;
// }

function calculResistance(
  tempBoucle: number,
  tempAmbiance: number,
  epaisseurIsolant: number,
  tube: RTubes_Type,
  isolant: RIsolantECS_Type
): number {
  //I12 : HI : 3800 constante
  let hi = 3800.0
  //C6 - diam extérieur
  //C8 - temperature depart boucle
  //C9 - temperature moyenne ambiance
  //C11 - epaisseur
  //var he = 1,32*(((C8-C9)/(C6/1000+C11/500))^0,25)
  let he = 1.32 * Math.pow((tempBoucle - tempAmbiance) / (tube.diamExt / 1000 + epaisseurIsolant / 500), 0.25)

  // rhi = 1/(I12*I8*PI())
  let rhi = 1 / (((hi * tube.diamInt) / 1000) * Math.PI)

  // rhe = 1/(PI()*I9* he) / I9 diametre ext avc isolant
  let diamExtIsolantMetr = (tube.diamExt + 2 * epaisseurIsolant) / 1000
  let rhe = 1 / (Math.PI * diamExtIsolantMetr * he)

  //rmat = (LN(I7/I8))/(2*PI()*C5)
  let rm = Math.log(tube.diamExt / tube.diamInt) / (2 * Math.PI * tube.conductivity)

  //riso = (LN(I9/I7))/(2*PI()*C10)
  var riso = 0.0
  if (isolant.lambda > 0) {
    riso = Math.log(diamExtIsolantMetr / (tube.diamExt / 1000)) / (2 * Math.PI * isolant.lambda)
  }
  return rhi + rhe + rm + riso
}

export default I01DEPBOUCECS_docalcul
